
import { empty } from 'rxjs'
import { FLUSH_EVENTS_URL, FLUSH_IMPERSONALIZED_EVENTS_URL, PostFunction, FLUSH_POST_IMPRESSIONS_URL } from 'interfaces/ajax'
import { PlainEvent, EventCategory, INSIGHT_EVENT_CATEGORY, IMPERSONALIZED_INSIGHT_EVENT_CATEGORY, POST_IMPRESSION_CATEGORY } from 'components/features/beacon/types'
import { SendEvent } from 'components/features/beacon/actions'
import { captureWarning } from 'helpers/errorHelpers'
import { IS_SEND_BEACON_SUPPORTED } from 'helpers/observableAjaxHelpers'

export const EVENTS_BUFFER_SIZE = IS_SEND_BEACON_SUPPORTED ? 5 : 1

export const sendEventsByCategory = (actions: SendEvent<EventCategory>[], category: EventCategory, sendBeacon: PostFunction) => {
  const events: PlainEvent[] = actions
    .filter((action): action is SendEvent<typeof INSIGHT_EVENT_CATEGORY> => {
      const { payload } = action
      return payload.category === category
    })
    .map(({ payload }) => ({
      name: payload.category + '/' + payload.event.name,
      data: payload.event.data,
    }))

  if (!events.length) {
    return empty()
  }

  if (category === INSIGHT_EVENT_CATEGORY) {
    return sendBeacon(FLUSH_EVENTS_URL, { body: { events }})
  }
  if (category === IMPERSONALIZED_INSIGHT_EVENT_CATEGORY) {
    return sendBeacon(FLUSH_IMPERSONALIZED_EVENTS_URL, { body: { events }})
  }

  captureWarning(`Some weird event category came, can't send these events`, {
    body: events,
    category,
  })

  return empty()
}

export const sendPostImpressions = (actions: SendEvent<EventCategory>[], sendBeacon: PostFunction) => {
  const postsUids = actions
    .filter((action): action is SendEvent<typeof POST_IMPRESSION_CATEGORY> => {
      return action.payload.category === POST_IMPRESSION_CATEGORY
    })
    .map((action) => action.payload.event.uid)

  if (postsUids.length === 0) {
    return empty()
  }

  return sendBeacon(FLUSH_POST_IMPRESSIONS_URL, {
    body: {
      viewed_posts_uids: postsUids,
    },
  })
}
